module.exports = __webpack_public_path__ + "img/SUSANA.2e0ea35e.jpeg";